<template>
  <el-dialog
    :visible="is_visible"
    ref="dialog"
    title="Настройка столбцов"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="$emit('close-popup')"
  >
    <div
      class="dialog__content content-offer"
      :key="updateKey"
      v-loading="loading"
    >
      <draggable
        group="columns"
        :list="editableColumns"
        :move="onChange"
        @end="recalculateOrderAndCompare"
        handle=".icon-handle"
      >
        <TableDialogColumn
          v-for="column in editableColumns"
          :key="column.name"
          :column="column"
          @set-selected="handleSelectColumn"
        />
      </draggable>
    </div>
    <div slot="footer">
      <div class="dialog__footer" v-loading="loading">
        <Button
          buttonSize="big"
          buttonColor="blue"
          buttonText="Сбросить"
          :disabled="noChanges"
          @click="
            () => {
              this.initArrays(true);
              this.noChanges = true;
            }
          "
          class="footer__button-cancel"
        />
        <Button
          buttonSize="big"
          buttonColor="darkBlue"
          buttonText="Применить"
          class="footer__button-ok"
          @click="saveColumns"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import { mixin } from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import draggable from 'vuedraggable';
import { MODULE, ACTION, DIALOG_WIDTH } from '@/utils/constants';
import { getController, postController } from '@/controllers/request';
import TableDialogColumn from 'Elements/Table/TableDialogColumn';

export default {
  mixins: [mixin],
  props: {
    is_visible: Boolean,
    module: {
      type: String,
      default: MODULE.CANDIDATES_MODULE
    },
    columnsParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: true,
      columns: [],
      editableColumns: [],
      originalColumns: [],
      noChanges: true,
      updateKey: 0
    };
  },
  async created() {
    try {
      const data =
        this.columnsParams?.intents && this.columnsParams?.intents?.length
          ? await this.sendFormRequestFromIntent(this.columnsParams.intents[0])
          : await getController({
              params: {
                module: this.module,
                to_pdf: true,
                action: ACTION.GET_LIST_TABLE_OPTIONS
              }
            });
      if (!data.data.error) {
        this.columns = data.data;
        this.initArrays();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    dialogWidth() {
      if (!this.columnsParams?.intents[0]?.size) {
        return DIALOG_WIDTH.S;
      }
      return (
        DIALOG_WIDTH[this.columnsParams?.intents[0]?.size] || DIALOG_WIDTH.S
      );
    }
  },
  methods: {
    onChange(event) {
      return !event.relatedContext.element.static;
    },
    initArrays(update) {
      this.originalColumns = [];
      this.editableColumns = [];
      for (let column of Object.keys(this.columns)) {
        this.originalColumns.push({ ...this.columns[column], name: column });
        this.editableColumns.push({ ...this.columns[column], name: column });
      }
      this.originalColumns.sort((prev, next) => prev.order - next.order);
      this.editableColumns.sort((prev, next) => prev.order - next.order);
      if (update) this.updateKey++;
    },
    compareArrays(arrayOne, arrayTwo) {
      for (let i = 0; i < arrayOne.length; i++) {
        if (JSON.stringify(arrayOne[i]) !== JSON.stringify(arrayTwo[i])) {
          return false;
        }
      }
      return true;
    },
    recalculateOrderAndCompare() {
      for (let i in this.editableColumns) {
        this.editableColumns[i].order = i++;
      }
      this.noChanges = this.compareArrays(
        this.editableColumns,
        this.originalColumns
      );
    },
    handleSelectColumn(val) {
      let column = this.editableColumns.find(elem => elem.order == val.order);
      const index = this.editableColumns.indexOf(column);
      column.visibility = val.value;
      this.$set(this.editableColumns, index, column);
      this.noChanges = this.compareArrays(
        this.editableColumns,
        this.originalColumns
      );
    },
    async saveColumns() {
      this.loading = true;
      const columns = {};
      for (let column of this.editableColumns) {
        const { name, ...filteredColumn } = column;
        columns[name] = filteredColumn;
      }
      const options = new FormData();

      options.append('module', this.module);
      options.append('action', 'saveTableOptions');
      options.append('contents', JSON.stringify(columns));
      options.append('to_pdf', 1);

      try {
        const data = await postController({ options });
        if (data.data.status === 'ok') {
          this.$emit('close-update');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  components: {
    draggable,
    'el-dialog': Dialog,
    Button,
    TableDialogColumn
  }
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper.search-col-dialog {
  & ::v-deep .el-dialog {
    min-width: 440px;
    padding: 0px !important;
    height: calc(100% - 80px) !important;

    & > .el-dialog__header {
      display: flex;
      align-items: center;
      padding: 20px 24px;
      border-bottom: 1px solid $black-20;

      & > .el-dialog__headerbtn {
        display: flex;
      }
    }

    & > .el-dialog__body {
      max-height: calc(100% - 130px) !important;
      padding: 8px 24px !important;
    }

    & > .el-dialog__footer {
      margin: 0;
      padding: 24px;
      border-top: 1px solid $black-20;
    }
  }

  & ::v-deep .dialog__content {
    min-height: 100%;
  }
}

.el-button:not(:last-of-type) {
  margin-right: 8px;
}
</style>
